import { LocalizedLink } from "../i18n/LocalizedLink";
import { useLocale } from "../i18n/useLocale";
import { SettingsMenuButton } from "../i18n/SettingsMenuButton";
import { PlaatplanLogo } from "./PlaatplanLogo";

export function SiteHeader() {
  const { display } = useLocale();

  return (
    <header className="app-header">
      <div className="brand">
        <LocalizedLink to="/" className="brand-link" aria-label={display.t("web.siteHeader.brandAria")}>
          <PlaatplanLogo className="brand-logo" size={38} />
        </LocalizedLink>
        <div>
          <p className="eyebrow">{display.t("web.shell.eyebrow")}</p>
          <LocalizedLink to="/" className="brand-name brand-name-link">
            Plaatplan
          </LocalizedLink>
        </div>
      </div>
      <div className="site-header-actions">
        <LocalizedLink to="/" className="primary-button site-nav-cta">
          {display.t("web.siteHeader.openPlanner")}
        </LocalizedLink>
        <SettingsMenuButton />
      </div>
    </header>
  );
}
